import type { IxcTradereportingV1Sec606AReportKeys } from '@interxfi/types';
import { type EntityPathBuilder, getResolvedPath } from '../../../util/routing/entity-paths';

export const SEC_606_REPORT_BASE_PATH = getResolvedPath('/clearing/compliance/reporting/sec-606');

export const getSec606ReportPath: EntityPathBuilder<IxcTradereportingV1Sec606AReportKeys> = (context) => {
  switch (context.kind) {
    case 'list':
      return SEC_606_REPORT_BASE_PATH;
    case 'detail': {
      if (!context?.keys?.reportId) {
        return undefined;
      }

      return getResolvedPath(`${SEC_606_REPORT_BASE_PATH}/$reportId`, context.keys);
    }
  }
};

export function getSec606ReportDetailPath(reportId: string | undefined) {
  if (!reportId) {
    return undefined;
  }

  return getSec606ReportPath({ kind: 'detail', keys: { reportId } });
}
